export const effieSystemStyles = `
  @keyframes float { 0%, 100% { transform: translateY(0px); } 50% { transform: translateY(-10px); } }
  @keyframes pulse-ring { 0% { transform: scale(0.8); opacity: 0.5; } 100% { transform: scale(2); opacity: 0; } }
  @keyframes scan-vertical { 0% { top: 0%; opacity: 0; } 10% { opacity: 1; } 90% { opacity: 1; } 100% { top: 100%; opacity: 0; } }
  @keyframes orbit { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
  @keyframes dash-flow { to { stroke-dashoffset: -20; } }
`;

export const effieOnboardStyles = `
        /* Glassmorphism Utilities */
        .glass { background: rgba(255, 255, 255, 0.03); backdrop-filter: blur(12px); border: 1px solid rgba(255, 255, 255, 0.1); }
        .glass-strong { background: rgba(11, 12, 16, 0.8); backdrop-filter: blur(20px); border: 1px solid rgba(69, 162, 158, 0.2); }
        
        /* Animation Keyframes */
        @keyframes orbit { from { transform: rotate(0deg) translateX(80px) rotate(0deg); } to { transform: rotate(360deg) translateX(80px) rotate(-360deg); } }
        @keyframes float { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-10px); } }
        @keyframes pulse-ring { 0% { transform: scale(0.9); opacity: 0.5; } 100% { transform: scale(1.6); opacity: 0; } }
        @keyframes chat-up { from { transform: translateY(20px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }
        @keyframes ingest { 0% { transform: translateY(0) scale(1); opacity: 1; } 50% { transform: translateY(40px) scale(0.5); opacity: 0.5; } 100% { transform: translateY(80px) scale(0); opacity: 0; } }
        @keyframes scan-bar { 0% { top: 0%; } 50% { top: 100%; } 100% { top: 0%; } }
        @keyframes spin-slow { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
        @keyframes dash-flow { to { stroke-dashoffset: -20; } }
      `;
